import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'hooks/apollo';
import { FakeText, Card, NavPills } from '@totalsoft/rocket-ui';
import { Toc as TocIcon } from '@mui/icons-material';
import { NavPillsCardContainer } from 'components/common/Styles';
import useLanguageTracker from 'hooks/useLanguageTracker';
import AccountStatementGeneralDataContainer from './generalData/AccountStatementGeneralDataContainer';
import AccountStatementDetailsBrowser from './details/AccountStatementDetailsBrowser';
import { ACCOUNT_STATEMENT_QUERY } from '../queries';
import AccountStatementIndicatorsContainer from './indicators/AccountStatementIndicatorsContainer';

const AccountStatementContainer = ({ canWrite, configId, onRedirect, onChangeTitle }) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const { data, loading, refetch } = useQuery(ACCOUNT_STATEMENT_QUERY, {
    onCompleted: data => {
      if (data?.accountStatement?.configName) {
        onChangeTitle(data.accountStatement.configName);
      }
    },
    variables: { configId },
    skip: !configId
  });

  const onLanguageChange = useCallback(() => {
    refetch();
  }, [refetch]);

  useLanguageTracker({
    onChange: onLanguageChange
  });

  return (
    <>
      {loading ? (
        <Card>
          <FakeText lines={15} />
        </Card>
      ) : (
        <>
          <AccountStatementGeneralDataContainer canWrite={canWrite} configId={configId} onRedirect={onRedirect} />
          <Card icon={TocIcon} iconColor='primary' title={t('InsuranceConventions.Details.Title')}>
            <NavPillsCardContainer disablePadding>
              <NavPills
                fullWidth
                active={active}
                onChange={(_event, active) => {
                  setActive(active);
                }}
                tabs={[
                  {
                    label: t('AccountStatement.Details.Title'),
                    content: (
                      <AccountStatementDetailsBrowser
                        canWrite={canWrite}
                        configId={configId}
                        usedByPartner={data?.accountStatement?.usedByPartner}
                      />
                    )
                  },
                  {
                    label: t('AccountStatement.Indicators.Title'),
                    content: (
                      <AccountStatementIndicatorsContainer
                        canWrite={canWrite}
                        statementIndicators={data?.accountStatement?.accountStatementIndicators}
                        configId={configId}
                        usedByPartner={data?.accountStatement?.usedByPartner}
                      />
                    )
                  }
                ]}
              />
            </NavPillsCardContainer>
          </Card>
        </>
      )}
    </>
  );
};

AccountStatementContainer.propTypes = {
  canWrite: PropTypes.bool,
  configId: PropTypes.number,
  onRedirect: PropTypes.func,
  onChangeTitle: PropTypes.func
};

export default AccountStatementContainer;
